import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/dist/types';
import { ApiConstants } from '../../shared/constants/api-constants';
import { QuarantinedDocumentsUpdateRequest } from '../models/quarantined-documents-update-request';
import { QuarantinedDocumentsRejectRequest } from '../models/quarantined-documents-reject-request';
import { QuarantinedDocumentIdentifier } from '../models/quarantined-document-identifier';

@Injectable({
  providedIn: 'root'
})
export class QuarantinedDocumentsService {

  constructor(private httpClient: HttpClient) { }

  getMyQuarantinedDocuments(includeAll: boolean): Observable<any> {
    return this.httpClient.get(ApiConstants.QuarantinedDocumentsGet_Api + includeAll);
  }

  releaseDocuments(releaseQuarantinedDocuments: QuarantinedDocumentsUpdateRequest[]): Observable<any> {
    return this.httpClient.post(ApiConstants.QuarantinedDocumentsrelease_Api, releaseQuarantinedDocuments);
  }

  rejectDocuments(rejectQuarantinedDocumentsRequest: QuarantinedDocumentsRejectRequest): Observable<any> {
    return this.httpClient.post(ApiConstants.QuarantinedDocumentsReject_Api, rejectQuarantinedDocumentsRequest);
  }
  
  getQuarantinedDocumentStatuses(request : QuarantinedDocumentIdentifier[]): Observable<any> {
    return this.httpClient.post(ApiConstants.QuarantinedDocumentsStatus_Api, request);  }
}
